import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {TravelsService, RoutingService, } from '../../services';
import {Travel} from "../../models";
import {STATE_NAMES} from "../../common";


@Component({
  selector: 'app-travels-list',
  templateUrl: './travels-list.html',
  styleUrls: ['./travels-list.scss']
})
export class TravelsListComponent implements OnInit {
  @Input() type: number;
  travels: any;
  isLoaded = false;

  constructor(
    private travelsService: TravelsService,
    private route: RoutingService,
  ){}

  ngOnInit() {
    this.getTravels();
   }


  private getTravels() {
    this.travels = [];
    let status = this.type == 1 ? 'active' :
        this.type == 2 ? 'new' :
            'past'
    this.travelsService.getTravelsByType({}, status).subscribe((res) => {
      if (res) {
        this.travels = res;
        this.isLoaded = true;
        console.log('!!!!this.travels', this.travels)
      }
    }, (err) => {
      this.isLoaded = true;
      console.log('!!!!err', err)
    });

  }

  openTravelProfile(e: any, travel: Travel) {
    const name = e.target ? e.target.className : e;

      // const clientName = `${ travel.dateFrom.format('DD.MM.YYYY')} - ${ travel.dateTo.format('DD.MM.YYYY')} ${travel.client.name}`;

      this.route.go(STATE_NAMES.travel, {
        id: travel.id,
        travel: travel,
      });

  }



}
